import { render, staticRenderFns } from "./BackupLink.vue?vue&type=template&id=e79a0082&scoped=true&"
import script from "./BackupLink.vue?vue&type=script&lang=js&"
export * from "./BackupLink.vue?vue&type=script&lang=js&"
import style0 from "./BackupLink.vue?vue&type=style&index=0&id=e79a0082&prod&lang=scss&scoped=true&"
import style1 from "./BackupLink.vue?vue&type=style&index=1&id=e79a0082&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79a0082",
  null
  
)

export default component.exports